export default function validateInfo(values,type) {
    let errors = {};

    if(type === 'meeting'){
      if (!values.fullname) {
        errors.fullname = 'Fullname Required!';
      } 
      if (!values.buttontext) {
        errors.buttontext = 'Please Enter Button Text';
      } 
      
      if (!values.meetingLink) {
        errors.meetingLink = 'Meeting Link Required!';
      } 

    }else if(type === 'cta'){
      if(values.formtype && values.formtype === 'text'){
        if(!values.text){
          errors.text = 'CTA Text Required!';
        }

        if(!values.link){
          errors.link = 'Link Required!';
        }

        if(values.link && !validURL(values.link)){
          errors.link = 'Enter URL is Invalid.';
        }
      }

      if(values.formtype && values.formtype === 'image'){
        
        if(!values.image){
          errors.image = 'Please upload Image!';
        }

        if(!values.link){
          errors.link = 'Link Required!';
        }

        if(values.link && !validURL(values.link)){
          errors.link = 'Enter URL is Invalid.';
        }
      }

    }else if(type === 'annotation'){
      if(!values.annotationText){
        errors.annotationText = 'Text Required!'
      }

      if(!values.annotationLink){
        errors.annotationLink = 'Link Required!'
      }

      if(values.annotationLink && !validURL(values.annotationLink)){
        errors.annotationLink = 'Enter URL is Invalid.';
      }

      if(!values.annotationStartTime){
        errors.annotationStartTime = 'Start Time Required!'
      }

      if(!values.annotationEndTime){
        errors.annotationEndTime = 'End Time Required!'
      }

      if(values.annotationEndTime <= values.annotationStartTime){
        errors.annotationEndTime = 'End time should be greater than start time.'
      }

      // console.log(Date.parse(values.annotationEndTime), parseInt(values.annotationStartTime),errors)

    }else if(type === 'copyPaste'){
      if(!values.CRMHtmlText){
        errors.CRMHtmlText = 'Please Enter Copy Paste Code here'
      }
    }else if(type === 'leadgenForm'){
      if(!values.headline){
        errors.headline = 'Title Required!'
      }

      if(!values.buttonname){
        errors.buttonname = 'Please Enter Button Name Here'
      }

    }else if(type === 'customPoll'){
      if(!values.question){
        errors.question = 'Please Enter Your Question'
      }

      if(!values.option1){
        errors.option1 = 'Please Enter Your Option 1 Value'
      }

      if(!values.option2){
        errors.option2 = 'Please Enter Your Option 2 Value'
      }
    }else if(type === 'branding'){
      if(values.player_addlink_chk && values.player_link.length === 0){
        errors.player_link = 'Please Enter your Player Link.'
      }

      if(values.player_link && !validURL(values.player_link)){
        errors.player_link = 'Enter URL is Invalid.';
      }
    }else if(type === 'privacy'){
      if(values.passwordchk && !values.passwordText){
        errors.passwordText = 'Please set password for video'
      }

      if(values.expirarychk && !values.expiraryTextTimeStamp){
        errors.expiraryText = 'Please set Expiry for video'
      }
    }else if(type === 'simple_reveal'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(!values.text2){
        errors.text2 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_bubble'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_bubble_2'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(!values.text2){
        errors.text2 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_bubble_3'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'speech_thought'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'border_animation'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'border_animation_2'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'lt_animation_1'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'lt_animation_2' || type === 'lt_animation_3' || type === 'lt_animation_4' || type === 'lt_animation_5'){
      if(!values.text1){
        errors.text1 = 'Please Enter Text'
      }

      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }

    }else if(type === 'emoji_content'){
      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }
    }else if(type === 'name_animation'){
      if(values.endTime <= values.startTime){
        errors.endTime = 'End time should be greater than start time.'
      }
    }


    return errors;
  }

  function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }